import { Loadable, LoadableFactory } from "shared/loadable";

export type Config = {
  queues: Record<string, string>;
  tarlConfig: TarlConfig;
};

export interface TarlConfig {
  host: string;
  port: number;
  scheme: string;
}

export type ConfigState = Loadable<Config>;

export const initialConfigState: ConfigState = LoadableFactory.loading();
